import { useState } from "react";
import UploadPage from "../pages/UploadPage";
import ReportsDashboard from "../pages/ReportsPage";
import LeadSearchForm from "../pages/LeadPage";
import { FiBarChart2, FiSearch, FiUploadCloud } from "react-icons/fi";
import "./DashboardTabs.css";

const DashboardTabs = () => {
  const [activeTab, setActiveTab] = useState("upload");

  const tabs = [
    { key: "upload", label: "Upload", icon: FiUploadCloud },
    { key: "reports", label: "Reports", icon: FiBarChart2 },
    { key: "leads", label: "Lead Search", icon: FiSearch },
  ];

  return (
    <main className="dashboard-page">
      <div className="dashboard-container">
        <header className="dashboard-header">
          <div>
            <p className="dashboard-kicker">Operations</p>
            <h1 className="dashboard-title">Email Automation Dashboard</h1>
            <p className="dashboard-subtitle">
              Upload campaign sheets, monitor delivery outcomes, and start targeted lead generation from one workspace.
            </p>
          </div>
        </header>

        <div className="workspace-layout">
          <aside className="workspace-rail">
            <div className="workspace-rail-header">
              <p className="workspace-label">Workspace</p>
              <h2 className="workspace-name">Email Operations</h2>
            </div>
            <div className="workspace-nav" role="tablist" aria-label="Email automation sections">
              {tabs.map((tab) => {
                const Icon = tab.icon;

                return (
                  <button
                    type="button"
                    key={tab.key}
                    className={`workspace-nav-item ${activeTab === tab.key ? "active" : ""}`}
                    onClick={() => setActiveTab(tab.key)}
                    role="tab"
                    aria-selected={activeTab === tab.key}
                  >
                    <Icon aria-hidden="true" />
                    <span>{tab.label}</span>
                  </button>
                );
              })}
            </div>
            <div className="workspace-insight">
              Keep campaign files, delivery reports, and lead requests in a single operating workspace.
            </div>
          </aside>

          <section className="workspace-content dashboard-panel dashboard-tabs-panel">
            <div className="dashboard-tab-content">
              {activeTab === "upload" && <UploadPage />}
              {activeTab === "reports" && <ReportsDashboard />}
              {activeTab === "leads" && <LeadSearchForm />}
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};

export default DashboardTabs;
